import { ApiError } from "./api.js";
import type { Locale } from "../i18n.js";

const messages: Record<string, [string, string]> = {
  guest_account_required: ["请先在「我的」保存为正式账户，再进入金币场。", "Save your guest account in Me before playing for coins."],
  insufficient_coins: ["金币不足，请选择更低档位或领取每日奖励。", "Choose a lower tier or claim your daily reward."],
  insufficient_level: ["等级尚未达到要求，请选择已解锁档位。", "Choose an unlocked tier while you build your level."],
  already_seated: ["你已有进行中的对局，请返回大厅继续。", "Return to the lobby to resume your current match."],
  already_in_lobby: ["你已在房间中，请返回大厅继续或先退出房间。", "Resume or leave your existing room from the lobby."],
  party_member_busy: ["队友正在其他活动中，请等待队友返回后重试。", "Your partner is busy. Retry when they return."],
  party_member_ineligible: ["队友未满足入场要求，请选择较低档位。", "Your partner cannot enter this tier. Choose a lower one."],
  invalid_party: ["队伍已失效，或你不是队长。请返回大厅检查队伍。", "This party is unavailable or you are not its host. Check your party in the lobby."],
  not_found: ["房间不存在或已结束，请检查房间码。", "This room is unavailable. Check the room code."],
  lobby_full: ["房间已满，请联系房主或加入其他房间。", "This room is full. Join another room."],
  invite_expired: ["邀请已过期，请让好友重新邀请。", "This invitation expired. Ask your friend for a new one."],
  queue_unavailable: ["匹配暂时不可用，请稍后重试。", "Matchmaking is unavailable. Please retry shortly."],
};
export function gameError(error: unknown, locale: Locale): string {
  const pair = error instanceof ApiError ? messages[error.code] : undefined;
  return pair?.[locale === "zh-CN" ? 0 : 1] ?? (locale === "zh-CN" ? "操作未完成，请检查网络后重试。" : "The action could not finish. Check your connection and retry.");
}
